// Util para resolver a base URL da API sem depender de authService
export const resolveBaseURL = (): string => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (envUrl) {
    return envUrl.endsWith('/') ? envUrl : `${envUrl}/`;
  }
  // Em ambiente de desenvolvimento, use caminho relativo para acionar o proxy
  if (process.env.NODE_ENV === 'development') {
    return '/api/';
  }
  try {
    const host = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
    const isLocal = host === 'localhost' || host === '127.0.0.1';
    const apiHost = isLocal ? 'localhost' : host;
    return `http://${apiHost}:8080/api/`;
  } catch {
    return 'http://localhost:8080/api/';
  }
};

export default resolveBaseURL;